// Approved 2026-10-27 additive GitHub setup extension; frozen source provenance below.
// Generated types/schemas from frozen v1 af1a0fb6 plus v1.1 overlay6a23c134.
// Browser validation is UX only; canonical server authorization is independent.
import { supabase } from "@/integrations/supabase/client";
import {
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
} from "@/integrations/supabase/config";
export type Context = {
  relationship_id: string;
  company_id: string;
  company_name: string;
  prime_label: string;
  role: "partner_admin" | "partner_recruiter" | "partner_viewer";
  capabilities: Array<
    | "users.manage"
    | "work.read"
    | "recruiting.read"
    | "recruiting.write"
    | "documents.read"
    | "documents.upload"
    | "contracts.request"
    | "delivery.write"
    | "scorecards.read"
  >;
  setup_state:
    | "invite_pending"
    | "password_setup"
    | "mfa_enrollment"
    | "mfa_challenge"
    | "ready"
    | "access_removed";
  version: number;
};
export type Relationship = {
  relationship_id: string;
  prime_org_id: string;
  partner_org_id: string;
  subcontractor_id: string;
  status: "active" | "suspended" | "revoked";
  version: number;
  company_name: string;
  prime_label: string;
  subcontractor_name: string;
};
export type Invitation = {
  invitation_id: string;
  relationship_id: string;
  role: "partner_admin" | "partner_recruiter" | "partner_viewer";
  status: "pending" | "accepted" | "revoked" | "superseded";
  expires_at: string;
  version: number;
  recipient_label: string;
  provision_state: "pending" | "ready" | "failed";
  delivery_state: "not_sent" | "queued" | "sent" | "failed";
  retryable: boolean;
};
export type Membership = {
  membership_id: string;
  relationship_id: string;
  user_id: string;
  role: "partner_admin" | "partner_recruiter" | "partner_viewer";
  capabilities: Array<
    | "users.manage"
    | "work.read"
    | "recruiting.read"
    | "recruiting.write"
    | "documents.read"
    | "documents.upload"
    | "contracts.request"
    | "delivery.write"
    | "scorecards.read"
  >;
  state: "pending" | "active" | "suspended" | "revoked";
  version: number;
  onboarding_state:
    "invite_pending" | "password_setup" | "mfa_enrollment" | "ready";
  award_access: Array<{
    award_version_id: string;
    delivery_write: boolean;
    delivery_document_upload: boolean;
  }>;
  verified_account_label: string;
};
export type AwardTerms = {
  number: string;
  title: string;
  scope: string;
  period_start: string | null;
  period_end: string | null;
  ceiling: number | null;
  funded: number | null;
  currency: string;
  status: "active" | "complete" | "cancelled";
};
export type Award = {
  vendor_order_id: string;
  award_version_id: string;
  relationship_id: string;
  contract_id: string;
  customer_task_order_id: string | null;
  version: number;
  terms: AwardTerms;
  published_at: string;
  status: "published" | "superseded" | "closed";
};
export type RateInput = {
  labor_category_id: string;
  amount: number;
  currency: string;
  unit_code: string;
  effective_from: string;
  effective_to: string | null;
};
export type Rate = {
  rate_schedule_version_id: string;
  relationship_id: string;
  award_version_id: string;
  terms: RateInput;
  version: number;
  status: "published" | "retired";
  visible_to_roles: Array<
    "partner_admin" | "partner_recruiter" | "partner_viewer"
  >;
  labor_category_title: string;
};
export type RequisitionProjection = {
  title: string;
  description: string;
  location: string | null;
  location_type: string | null;
  requirements: Array<string>;
  deadline: string | null;
  headcount: number;
};
export type Share = {
  share_id: string;
  relationship_id: string;
  award_version_id: string;
  vendor_order_id: string;
  customer_task_order_id: string | null;
  requisition_id: string;
  requisition_version: number;
  requirements: RequisitionProjection;
  rate_schedule_version_id: string;
  status: "active" | "revoked" | "closed";
  version: number;
  visible_to_roles: Array<
    "partner_admin" | "partner_recruiter" | "partner_viewer"
  >;
};
export type CandidateInput = {
  name: string;
  email: string | null;
  skills: Array<string>;
  qualification_summary: string;
  resume_document_id: string | null;
  policy_version_id: string;
  notice_receipt_id: string;
  rate_schedule_version_id: string;
};
export type Submission = {
  submission_id: string;
  relationship_id: string;
  share_id: string;
  award_version_id: string;
  candidate: CandidateInput;
  state: "draft" | "submitted" | "withdrawn";
  candidate_submission_id: string | null;
  released_pipeline_status:
    | "applied"
    | "screening"
    | "submitted_to_client"
    | "interviewed"
    | "offered"
    | "placed"
    | "rejected"
    | "withdrawn"
    | null;
  released_reason: string | null;
  version: number;
};
export type DocumentMetadata = {
  relationship_id: string;
  parent_kind: "submission" | "award_version";
  parent_id: string;
  kind: "award" | "resume" | "change_support" | "delivery_support";
  title: string;
  policy_version_id: string | null;
  notice_receipt_id: string | null;
};
export type Document = {
  document_id: string;
  relationship_id: string;
  parent_kind: "submission" | "award_version";
  parent_id: string;
  kind: "award" | "resume" | "change_support" | "delivery_support";
  title: string;
  media_type:
    | "application/pdf"
    | "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    | "text/plain";
  bytes: number;
  state: "staged" | "quarantined" | "released" | "revoked";
  version: number;
};
export type ChangePayload = {
  summary: string;
  requested_change: string;
  document_ids: Array<string>;
};
export type DeliveryPayload = {
  summary: string;
  occurred_at: string;
  document_ids: Array<string>;
};
export type ContractAction =
  | {
      action_id: string;
      relationship_id: string;
      award_version_id: string;
      kind: "acknowledgment";
      state:
        | "recorded"
        | "submitted"
        | "under_review"
        | "accepted"
        | "rejected"
        | "withdrawn";
      released_reason: string | null;
      created_at: string;
      version: number;
      content: { acknowledgment: "ACKNOWLEDGE_RECEIPT" };
    }
  | {
      action_id: string;
      relationship_id: string;
      award_version_id: string;
      kind: "change_request";
      state:
        | "recorded"
        | "submitted"
        | "under_review"
        | "accepted"
        | "rejected"
        | "withdrawn";
      released_reason: string | null;
      created_at: string;
      version: number;
      content: ChangePayload;
    }
  | {
      action_id: string;
      relationship_id: string;
      award_version_id: string;
      kind: "delivery_update";
      state:
        | "recorded"
        | "submitted"
        | "under_review"
        | "accepted"
        | "rejected"
        | "withdrawn";
      released_reason: string | null;
      created_at: string;
      version: number;
      content: DeliveryPayload;
    };
export type MetricDefinition = {
  metric_key: string;
  label: string;
  unit_code: string;
  numerator_rule: string;
  denominator_rule: string | null;
  target: number | null;
  roles: Array<"partner_admin" | "partner_recruiter" | "partner_viewer">;
};
export type Metric = {
  metric_key: string;
  definition_version: number;
  numerator: number | null;
  denominator: number | null;
  value: number | null;
  unit_code: string;
  target: number | null;
  availability: "available" | "no_data" | "unavailable";
};
export type Scorecard = {
  relationship_id: string;
  award_version_id: string | null;
  configured: boolean;
  released: boolean;
  period_start: string;
  period_end: string;
  metrics: Array<Metric>;
  source_watermark: string | null;
};
/** One measure of a released period, labelled with the admin's wording. */
export type ReleasedMeasure = Metric & { label: string };
export type ScorecardReleasePeriod = {
  period_start: string;
  period_end: string;
  released_at: string;
  metrics: Array<ReleasedMeasure>;
};
export type ScorecardReleasePeriods = {
  relationship_id: string;
  award_version_id: string | null;
  periods: Array<ScorecardReleasePeriod>;
};
export type ScorecardMeasureKey =
  | "on_time_deliverables"
  | "staffing_coverage"
  | "fill_rate"
  | "retained_placements"
  | "submissions"
  | "decisions"
  | "qualified_submissions";
/** Setup of one whole reporting month: not set up, ready to publish, or published. */
export type ScorecardSetup = {
  relationship_id: string;
  period_start: string;
  period_end: string;
  state: "not_set_up" | "ready" | "published";
  version: number;
  carried_over: boolean;
  last_period: { period_start: string; period_end: string } | null;
  released_at: string | null;
  policy_version: number | null;
  definitions: Array<MetricDefinition>;
  measures: Array<{
    measure_key: ScorecardMeasureKey;
    label: string;
    explanation: string;
    unit_code: string;
    selected: boolean;
    needs_deliverables: boolean;
    record_count: number | null;
  }>;
  excluded_positions: number;
  excluded_shared_deliverables?: number;
  deliverables: Array<{
    deliverable_id: string;
    title: string;
    due_date: string;
    status: string;
    selected: boolean;
  }>;
  deliverables_truncated: boolean;
};
export type VersionResult = { id: string; version: number; state: string };
export type SuccessMeta = { request_id: string };
export type Error = {
  ok: false;
  error: {
    code:
      | "unauthenticated"
      | "not_available"
      | "permission_denied"
      | "mfa_required"
      | "step_up_required"
      | "conflict"
      | "invalid_input"
      | "rate_limited"
      | "policy_unconfigured"
      | "temporary_failure";
    message: string;
    request_id: string;
    retry_after_seconds?: number;
    required_action?:
      | "sign_in"
      | "enroll_mfa"
      | "challenge_mfa"
      | "step_up"
      | "retry"
      | "contact_support";
  };
};
export type IntakePolicy = {
  relationship_id: string;
  configured: boolean;
  policy_version_id: string | null;
  notice_text: string | null;
  required_attestation_text: string | null;
  retention_policy_label: string | null;
  collection_allowed: boolean;
};
export type NoticeReceipt = {
  notice_receipt_id: string;
  relationship_id: string;
  share_id: string;
  policy_version_id: string;
  attested_by: string;
  recorded_at: string;
};
export type PartnerCompany = {
  partner_org_id: string;
  name: string;
  status: "active" | "suspended" | "archived";
};
export type AwardPage = { items: Array<Award>; next_cursor: string | null };
export type SharePage = { items: Array<Share>; next_cursor: string | null };
export type RatePage = { items: Array<Rate>; next_cursor: string | null };
export type SubmissionPage = {
  items: Array<Submission>;
  next_cursor: string | null;
};
export type DocumentPage = {
  items: Array<Document>;
  next_cursor: string | null;
};
export type ContractActionPage = {
  items: Array<ContractAction>;
  next_cursor: string | null;
};
export type MembershipPage = {
  items: Array<Membership>;
  next_cursor: string | null;
};
export type InvitationPage = {
  items: Array<Invitation>;
  next_cursor: string | null;
};
export type Contexts = { contexts: Array<Context> };
export type RelationshipPage = {
  items: Array<Relationship>;
  next_cursor: string | null;
};
export type SetupResult = {
  relationship_id: string;
  state: "password_setup" | "mfa_enrollment" | "mfa_challenge" | "ready";
  version: number;
};
export type PrimeSourceSubcontractors = {
  id: string;
  name: string;
  status: string;
};
export type PrimeSourcePartnerCompanies = {
  partner_org_id: string;
  name: string;
  status: "active" | "suspended" | "archived";
};
export type PrimeSourceVendorOrders = {
  id: string;
  to_number: string;
  title: string;
  contract_id: string;
  customer_task_order_id: string | null;
  status: string;
  updated_at: string;
};
export type PrimeSourceRequisitions = {
  id: string;
  title: string;
  status: "approved" | "sourcing";
  version: number;
  updated_at: string;
  labor_category_id: string | null;
};
export type PrimeSourceLaborCategories = { id: string; title: string };
export type PrimePartnerSourceOptions =
  | {
      kind: "subcontractors";
      items: Array<PrimeSourceSubcontractors>;
      next_cursor: string | null;
    }
  | {
      kind: "partner_companies";
      items: Array<PrimeSourcePartnerCompanies>;
      next_cursor: string | null;
    }
  | {
      kind: "vendor_orders";
      items: Array<PrimeSourceVendorOrders>;
      next_cursor: string | null;
    }
  | {
      kind: "requisitions";
      items: Array<PrimeSourceRequisitions>;
      next_cursor: string | null;
    }
  | {
      kind: "labor_categories";
      items: Array<PrimeSourceLaborCategories>;
      next_cursor: string | null;
    };
export interface PartnerRequests {
  get_my_partner_contexts: Record<string, never>;
  provision_partner_company: {
    prime_org_id: string;
    name: string;
    time_zone: string;
    linkage_attestation: string;
    idempotency_key: string;
  };
  create_partner_relationship: {
    prime_org_id: string;
    partner_org_id: string;
    subcontractor_id: string;
    linkage_attestation: string;
    idempotency_key: string;
  };
  set_partner_relationship_state: {
    relationship_id: string;
    state: "active" | "suspended" | "revoked";
    reason: string;
    idempotency_key: string;
    expected_version: number;
  };
  invite_partner_user: {
    relationship_id: string;
    email: string;
    role: "partner_admin" | "partner_recruiter" | "partner_viewer";
    capabilities: Array<
      | "users.manage"
      | "work.read"
      | "recruiting.read"
      | "recruiting.write"
      | "documents.read"
      | "documents.upload"
      | "contracts.request"
      | "delivery.write"
      | "scorecards.read"
    >;
    idempotency_key: string;
  };
  accept_partner_invitation: { opaque_token: string; idempotency_key: string };
  resend_partner_invitation: {
    relationship_id: string;
    invitation_id: string;
    idempotency_key: string;
    expected_version: number;
  };
  revoke_partner_invitation: {
    relationship_id: string;
    invitation_id: string;
    reason: string;
    idempotency_key: string;
    expected_version: number;
  };
  get_partner_invitations: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
  };
  get_partner_memberships: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
  };
  set_partner_membership: {
    relationship_id: string;
    membership_id: string;
    role: "partner_admin" | "partner_recruiter" | "partner_viewer";
    capabilities: Array<
      | "users.manage"
      | "work.read"
      | "recruiting.read"
      | "recruiting.write"
      | "documents.read"
      | "documents.upload"
      | "contracts.request"
      | "delivery.write"
      | "scorecards.read"
    >;
    state: "active" | "suspended" | "revoked";
    replacement_administrator_membership_id: string | null;
    idempotency_key: string;
    expected_version: number;
    award_access: Array<{
      award_version_id: string;
      delivery_write: boolean;
      delivery_document_upload: boolean;
    }>;
  };
  publish_partner_award: {
    relationship_id: string;
    vendor_order_id: string;
    contract_id: string;
    customer_task_order_id: string | null;
    terms: AwardTerms;
    idempotency_key: string;
    expected_vendor_order_updated_at: string;
  };
  get_partner_awards: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
  };
  publish_partner_rate: {
    relationship_id: string;
    award_version_id: string;
    terms: RateInput;
    idempotency_key: string;
    visible_to_roles: Array<
      "partner_admin" | "partner_recruiter" | "partner_viewer"
    >;
  };
  retire_partner_rate: {
    relationship_id: string;
    rate_schedule_version_id: string;
    reason: string;
    idempotency_key: string;
    expected_version: number;
  };
  share_partner_requisition: {
    relationship_id: string;
    award_version_id: string;
    requisition_id: string;
    source_requisition_version: number;
    requirements: RequisitionProjection;
    rate_schedule_version_id: string;
    idempotency_key: string;
    visible_to_roles: Array<
      "partner_admin" | "partner_recruiter" | "partner_viewer"
    >;
  };
  revoke_partner_requisition_share: {
    relationship_id: string;
    share_id: string;
    reason: string;
    idempotency_key: string;
    expected_version: number;
  };
  get_partner_requisitions: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
  };
  get_partner_intake_policy: { relationship_id: string };
  attest_partner_candidate_notice: {
    relationship_id: string;
    share_id: string;
    policy_version_id: string;
    attested: true;
    evidence_reference: string | null;
    idempotency_key: string;
  };
  create_partner_submission_draft: {
    relationship_id: string;
    share_id: string;
    candidate: CandidateInput;
    idempotency_key: string;
  };
  update_partner_submission_draft: {
    relationship_id: string;
    submission_id: string;
    candidate: CandidateInput;
    idempotency_key: string;
    expected_version: number;
  };
  submit_partner_candidate: {
    relationship_id: string;
    submission_id: string;
    idempotency_key: string;
    expected_version: number;
  };
  withdraw_partner_candidate: {
    relationship_id: string;
    submission_id: string;
    idempotency_key: string;
    expected_version: number;
  };
  get_partner_submissions: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
    share_id: string | null;
  };
  publish_partner_candidate_decision: {
    relationship_id: string;
    submission_id: string;
    pipeline_status:
      | "applied"
      | "screening"
      | "submitted_to_client"
      | "interviewed"
      | "offered"
      | "placed"
      | "rejected"
      | "withdrawn";
    released_reason: string | null;
    idempotency_key: string;
    expected_version: number;
  };
  release_partner_document: {
    relationship_id: string;
    document_id: string;
    idempotency_key: string;
    expected_version: number;
  };
  revoke_partner_document: {
    relationship_id: string;
    document_id: string;
    reason: string;
    idempotency_key: string;
    expected_version: number;
  };
  get_partner_documents: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
    parent_kind: "submission" | "award_version";
    parent_id: string;
  };
  acknowledge_partner_award: {
    relationship_id: string;
    award_version_id: string;
    acknowledgment: "ACKNOWLEDGE_RECEIPT";
    idempotency_key: string;
  };
  request_partner_contract_change: {
    relationship_id: string;
    award_version_id: string;
    request: ChangePayload;
    idempotency_key: string;
  };
  withdraw_partner_contract_change: {
    relationship_id: string;
    action_id: string;
    idempotency_key: string;
    expected_version: number;
  };
  resolve_partner_contract_change: {
    relationship_id: string;
    action_id: string;
    decision: "under_review" | "accepted" | "rejected";
    released_reason: string;
    new_award_version_id: string | null;
    idempotency_key: string;
    expected_version: number;
  };
  append_partner_delivery_update: {
    relationship_id: string;
    award_version_id: string;
    update: DeliveryPayload;
    idempotency_key: string;
  };
  get_partner_contract_actions: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
    award_version_id: string;
  };
  publish_partner_scorecard: {
    relationship_id: string;
    award_version_id: string | null;
    period_start: string;
    period_end: string;
    definitions: Array<MetricDefinition>;
    policy_version: number;
    idempotency_key: string;
  };
  get_partner_scorecard: {
    relationship_id: string;
    award_version_id: string | null;
    period_start: string;
    period_end: string;
  };
  list_partner_scorecard_releases: {
    relationship_id: string;
    award_version_id: string | null;
  };
  get_partner_scorecard_setup: {
    relationship_id: string;
    period_start: string;
  };
  save_partner_scorecard_setup: {
    relationship_id: string;
    period_start: string;
    measures: Array<ScorecardMeasureKey>;
    deliverable_ids: Array<string>;
    expected_version: number;
    idempotency_key: string;
  };
  get_prime_partner_relationships: {
    prime_org_id: string;
    cursor: string | null;
    page_size: number;
  };
  get_partner_rates: {
    relationship_id: string;
    cursor: string | null;
    page_size: number;
    award_version_id: string | null;
  };
  set_partner_initial_password: {
    relationship_id: string;
    password: string;
    expected_version: number;
    idempotency_key: string;
  };
  complete_partner_setup: {
    relationship_id: string;
    method: "password" | "google" | "github";
    expected_version: number;
    idempotency_key: string;
  };
  get_prime_partner_source_options:
    | {
        prime_org_id: string;
        relationship_id: null;
        award_version_id: null;
        kind: "subcontractors";
        cursor: string | null;
        page_size: number;
      }
    | {
        prime_org_id: string;
        relationship_id: null;
        award_version_id: null;
        kind: "partner_companies";
        cursor: string | null;
        page_size: number;
      }
    | {
        prime_org_id: string;
        relationship_id: string;
        award_version_id: null;
        kind: "vendor_orders";
        cursor: string | null;
        page_size: number;
      }
    | {
        prime_org_id: string;
        relationship_id: string;
        award_version_id: string;
        kind: "requisitions";
        cursor: string | null;
        page_size: number;
      }
    | {
        prime_org_id: string;
        relationship_id: string;
        award_version_id: string;
        kind: "labor_categories";
        cursor: string | null;
        page_size: number;
      };
}
export interface PartnerResults {
  get_my_partner_contexts: Contexts;
  provision_partner_company: PartnerCompany;
  create_partner_relationship: Relationship;
  set_partner_relationship_state: Relationship;
  invite_partner_user: Invitation;
  accept_partner_invitation: Membership;
  resend_partner_invitation: Invitation;
  revoke_partner_invitation: Invitation;
  get_partner_invitations: InvitationPage;
  get_partner_memberships: MembershipPage;
  set_partner_membership: Membership;
  publish_partner_award: Award;
  get_partner_awards: AwardPage;
  publish_partner_rate: Rate;
  retire_partner_rate: Rate;
  share_partner_requisition: Share;
  revoke_partner_requisition_share: Share;
  get_partner_requisitions: SharePage;
  get_partner_intake_policy: IntakePolicy;
  attest_partner_candidate_notice: NoticeReceipt;
  create_partner_submission_draft: Submission;
  update_partner_submission_draft: Submission;
  submit_partner_candidate: Submission;
  withdraw_partner_candidate: Submission;
  get_partner_submissions: SubmissionPage;
  publish_partner_candidate_decision: Submission;
  release_partner_document: Document;
  revoke_partner_document: Document;
  get_partner_documents: DocumentPage;
  acknowledge_partner_award: ContractAction;
  request_partner_contract_change: ContractAction;
  withdraw_partner_contract_change: ContractAction;
  resolve_partner_contract_change: ContractAction;
  append_partner_delivery_update: ContractAction;
  get_partner_contract_actions: ContractActionPage;
  publish_partner_scorecard: Scorecard;
  get_partner_scorecard: Scorecard;
  list_partner_scorecard_releases: ScorecardReleasePeriods;
  get_partner_scorecard_setup: ScorecardSetup;
  save_partner_scorecard_setup: ScorecardSetup;
  get_prime_partner_relationships: RelationshipPage;
  get_partner_rates: RatePage;
  set_partner_initial_password: SetupResult;
  complete_partner_setup: SetupResult;
  get_prime_partner_source_options: PrimePartnerSourceOptions;
}
export type PartnerOperation = keyof PartnerRequests;
type Schema = {
  $ref?: string;
  const?: unknown;
  enum?: unknown[];
  oneOf?: Schema[];
  anyOf?: Schema[];
  type?: string;
  properties?: Record<string, Schema>;
  required?: string[];
  additionalProperties?: boolean;
  items?: Schema;
  maxItems?: number;
  uniqueItems?: boolean;
  minLength?: number;
  maxLength?: number;
  minimum?: number;
  maximum?: number;
  pattern?: string;
  format?: string;
};
const definitions: Record<string, Schema> = {
  Context: {
    type: "object",
    properties: {
      relationship_id: { type: "string", format: "uuid" },
      company_id: { type: "string", format: "uuid" },
      company_name: { type: "string", minLength: 1, maxLength: 200 },
      prime_label: { type: "string", minLength: 1, maxLength: 200 },
      role: {
        type: "string",
        enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
      },
      capabilities: {
        type: "array",
        items: {
          type: "string",
          enum: [
            "users.manage",
            "work.read",
            "recruiting.read",
            "recruiting.write",
            "documents.read",
            "documents.upload",
            "contracts.request",
            "delivery.write",
            "scorecards.read",
          ],
        },
        maxItems: 9,
      },
      setup_state: {
        type: "string",
        enum: [
          "invite_pending",
          "password_setup",
          "mfa_enrollment",
          "mfa_challenge",
          "ready",
          "access_removed",
        ],
      },
      version: { type: "integer", minimum: 1 },
    },
    required: [
      "relationship_id",
      "company_id",
      "company_name",
      "prime_label",
      "role",
      "capabilities",
      "setup_state",
      "version",
    ],
    additionalProperties: false,
  },
  Relationship: {
    type: "object",
    properties: {
      relationship_id: { type: "string", format: "uuid" },
      prime_org_id: { type: "string", format: "uuid" },
      partner_org_id: { type: "string", format: "uuid" },
      subcontractor_id: { type: "string", format: "uuid" },
      status: { type: "string", enum: ["active", "suspended", "revoked"] },
      version: { type: "integer", minimum: 1 },
      company_name: { type: "string", minLength: 1, maxLength: 200 },
      prime_label: { type: "string", minLength: 1, maxLength: 200 },
      subcontractor_name: { type: "string", minLength: 1, maxLength: 200 },
    },
    required: [
      "relationship_id",
      "prime_org_id",
      "partner_org_id",
      "subcontractor_id",
      "status",
      "version",
      "company_name",
      "prime_label",
      "subcontractor_name",
    ],
    additionalProperties: false,
  },
  Invitation: {
    type: "object",
    properties: {
      invitation_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      role: {
        type: "string",
        enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
      },
      status: {
        type: "string",
        enum: ["pending", "accepted", "revoked", "superseded"],
      },
      expires_at: { type: "string", format: "date-time" },
      version: { type: "integer", minimum: 1 },
      recipient_label: { type: "string", maxLength: 320 },
      provision_state: { type: "string", enum: ["pending", "ready", "failed"] },
      delivery_state: {
        type: "string",
        enum: ["not_sent", "queued", "sent", "failed"],
      },
      retryable: { type: "boolean" },
    },
    required: [
      "invitation_id",
      "relationship_id",
      "role",
      "status",
      "expires_at",
      "version",
      "recipient_label",
      "provision_state",
      "delivery_state",
      "retryable",
    ],
    additionalProperties: false,
  },
  Membership: {
    type: "object",
    properties: {
      membership_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      user_id: { type: "string", format: "uuid" },
      role: {
        type: "string",
        enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
      },
      capabilities: {
        type: "array",
        items: {
          type: "string",
          enum: [
            "users.manage",
            "work.read",
            "recruiting.read",
            "recruiting.write",
            "documents.read",
            "documents.upload",
            "contracts.request",
            "delivery.write",
            "scorecards.read",
          ],
        },
        maxItems: 9,
      },
      state: {
        type: "string",
        enum: ["pending", "active", "suspended", "revoked"],
      },
      version: { type: "integer", minimum: 1 },
      onboarding_state: {
        type: "string",
        enum: ["invite_pending", "password_setup", "mfa_enrollment", "ready"],
      },
      award_access: {
        type: "array",
        maxItems: 100,
        items: {
          type: "object",
          properties: {
            award_version_id: { type: "string", format: "uuid" },
            delivery_write: { type: "boolean" },
            delivery_document_upload: { type: "boolean" },
          },
          required: [
            "award_version_id",
            "delivery_write",
            "delivery_document_upload",
          ],
          additionalProperties: false,
        },
      },
      verified_account_label: { type: "string", minLength: 1, maxLength: 320 },
    },
    required: [
      "membership_id",
      "relationship_id",
      "user_id",
      "role",
      "capabilities",
      "state",
      "version",
      "onboarding_state",
      "award_access",
      "verified_account_label",
    ],
    additionalProperties: false,
  },
  AwardTerms: {
    type: "object",
    properties: {
      number: { type: "string", minLength: 1, maxLength: 200 },
      title: { type: "string", minLength: 1, maxLength: 200 },
      scope: { type: "string", maxLength: 5000 },
      period_start: {
        anyOf: [{ type: "string", format: "date" }, { type: "null" }],
      },
      period_end: {
        anyOf: [{ type: "string", format: "date" }, { type: "null" }],
      },
      ceiling: { anyOf: [{ type: "number", minimum: 0 }, { type: "null" }] },
      funded: { anyOf: [{ type: "number", minimum: 0 }, { type: "null" }] },
      currency: { type: "string", pattern: "^[A-Z]{3}$" },
      status: { type: "string", enum: ["active", "complete", "cancelled"] },
    },
    required: [
      "number",
      "title",
      "scope",
      "period_start",
      "period_end",
      "ceiling",
      "funded",
      "currency",
      "status",
    ],
    additionalProperties: false,
  },
  Award: {
    type: "object",
    properties: {
      vendor_order_id: { type: "string", format: "uuid" },
      award_version_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      contract_id: { type: "string", format: "uuid" },
      customer_task_order_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      version: { type: "integer", minimum: 1 },
      terms: { $ref: "#/$defs/AwardTerms" },
      published_at: { type: "string", format: "date-time" },
      status: { type: "string", enum: ["published", "superseded", "closed"] },
    },
    required: [
      "vendor_order_id",
      "award_version_id",
      "relationship_id",
      "contract_id",
      "customer_task_order_id",
      "version",
      "terms",
      "published_at",
      "status",
    ],
    additionalProperties: false,
  },
  RateInput: {
    type: "object",
    properties: {
      labor_category_id: { type: "string", format: "uuid" },
      amount: { type: "number", minimum: 0 },
      currency: { type: "string", pattern: "^[A-Z]{3}$" },
      unit_code: { type: "string", minLength: 1, maxLength: 32 },
      effective_from: { type: "string", format: "date-time" },
      effective_to: {
        anyOf: [{ type: "string", format: "date-time" }, { type: "null" }],
      },
    },
    required: [
      "labor_category_id",
      "amount",
      "currency",
      "unit_code",
      "effective_from",
      "effective_to",
    ],
    additionalProperties: false,
  },
  Rate: {
    type: "object",
    properties: {
      rate_schedule_version_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      award_version_id: { type: "string", format: "uuid" },
      terms: { $ref: "#/$defs/RateInput" },
      version: { type: "integer", minimum: 1 },
      status: { type: "string", enum: ["published", "retired"] },
      visible_to_roles: {
        type: "array",
        items: {
          type: "string",
          enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
        },
        maxItems: 3,
        uniqueItems: true,
      },
      labor_category_title: { type: "string", minLength: 1, maxLength: 200 },
    },
    required: [
      "rate_schedule_version_id",
      "relationship_id",
      "award_version_id",
      "terms",
      "version",
      "status",
      "visible_to_roles",
      "labor_category_title",
    ],
    additionalProperties: false,
  },
  RequisitionProjection: {
    type: "object",
    properties: {
      title: { type: "string", minLength: 1, maxLength: 200 },
      description: { type: "string", maxLength: 5000 },
      location: {
        anyOf: [
          { type: "string", minLength: 1, maxLength: 200 },
          { type: "null" },
        ],
      },
      location_type: {
        anyOf: [
          { type: "string", minLength: 1, maxLength: 200 },
          { type: "null" },
        ],
      },
      requirements: {
        type: "array",
        items: { type: "string", maxLength: 2000 },
        maxItems: 50,
      },
      deadline: {
        anyOf: [{ type: "string", format: "date-time" }, { type: "null" }],
      },
      headcount: { type: "integer", minimum: 1, maximum: 10000 },
    },
    required: [
      "title",
      "description",
      "location",
      "location_type",
      "requirements",
      "deadline",
      "headcount",
    ],
    additionalProperties: false,
  },
  Share: {
    type: "object",
    properties: {
      share_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      award_version_id: { type: "string", format: "uuid" },
      vendor_order_id: { type: "string", format: "uuid" },
      customer_task_order_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      requisition_id: { type: "string", format: "uuid" },
      requisition_version: { type: "integer", minimum: 1 },
      requirements: { $ref: "#/$defs/RequisitionProjection" },
      rate_schedule_version_id: { type: "string", format: "uuid" },
      status: { type: "string", enum: ["active", "revoked", "closed"] },
      version: { type: "integer", minimum: 1 },
      visible_to_roles: {
        type: "array",
        items: {
          type: "string",
          enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
        },
        maxItems: 3,
        uniqueItems: true,
      },
    },
    required: [
      "share_id",
      "relationship_id",
      "award_version_id",
      "vendor_order_id",
      "customer_task_order_id",
      "requisition_id",
      "requisition_version",
      "requirements",
      "rate_schedule_version_id",
      "status",
      "version",
      "visible_to_roles",
    ],
    additionalProperties: false,
  },
  CandidateInput: {
    type: "object",
    properties: {
      name: { type: "string", minLength: 1, maxLength: 200 },
      email: {
        anyOf: [
          { type: "string", format: "email", maxLength: 320 },
          { type: "null" },
        ],
      },
      skills: {
        type: "array",
        items: { type: "string", maxLength: 100 },
        maxItems: 100,
      },
      qualification_summary: { type: "string", maxLength: 5000 },
      resume_document_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      policy_version_id: { type: "string", format: "uuid" },
      notice_receipt_id: { type: "string", format: "uuid" },
      rate_schedule_version_id: { type: "string", format: "uuid" },
    },
    required: [
      "name",
      "email",
      "skills",
      "qualification_summary",
      "resume_document_id",
      "policy_version_id",
      "notice_receipt_id",
      "rate_schedule_version_id",
    ],
    additionalProperties: false,
  },
  Submission: {
    type: "object",
    properties: {
      submission_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      share_id: { type: "string", format: "uuid" },
      award_version_id: { type: "string", format: "uuid" },
      candidate: { $ref: "#/$defs/CandidateInput" },
      state: { type: "string", enum: ["draft", "submitted", "withdrawn"] },
      candidate_submission_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      released_pipeline_status: {
        anyOf: [
          {
            type: "string",
            enum: [
              "applied",
              "screening",
              "submitted_to_client",
              "interviewed",
              "offered",
              "placed",
              "rejected",
              "withdrawn",
            ],
          },
          { type: "null" },
        ],
      },
      released_reason: {
        anyOf: [{ type: "string", maxLength: 5000 }, { type: "null" }],
      },
      version: { type: "integer", minimum: 1 },
    },
    required: [
      "submission_id",
      "relationship_id",
      "share_id",
      "award_version_id",
      "candidate",
      "state",
      "candidate_submission_id",
      "released_pipeline_status",
      "released_reason",
      "version",
    ],
    additionalProperties: false,
  },
  DocumentMetadata: {
    type: "object",
    properties: {
      relationship_id: { type: "string", format: "uuid" },
      parent_kind: { type: "string", enum: ["submission", "award_version"] },
      parent_id: { type: "string", format: "uuid" },
      kind: {
        type: "string",
        enum: ["award", "resume", "change_support", "delivery_support"],
      },
      title: { type: "string", minLength: 1, maxLength: 200 },
      policy_version_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      notice_receipt_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
    },
    required: [
      "relationship_id",
      "parent_kind",
      "parent_id",
      "kind",
      "title",
      "policy_version_id",
      "notice_receipt_id",
    ],
    additionalProperties: false,
  },
  Document: {
    type: "object",
    properties: {
      document_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      parent_kind: { type: "string", enum: ["submission", "award_version"] },
      parent_id: { type: "string", format: "uuid" },
      kind: {
        type: "string",
        enum: ["award", "resume", "change_support", "delivery_support"],
      },
      title: { type: "string", minLength: 1, maxLength: 200 },
      media_type: {
        type: "string",
        enum: [
          "application/pdf",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "text/plain",
        ],
      },
      bytes: { type: "integer", minimum: 1, maximum: 10485760 },
      state: {
        type: "string",
        enum: ["staged", "quarantined", "released", "revoked"],
      },
      version: { type: "integer", minimum: 1 },
    },
    required: [
      "document_id",
      "relationship_id",
      "parent_kind",
      "parent_id",
      "kind",
      "title",
      "media_type",
      "bytes",
      "state",
      "version",
    ],
    additionalProperties: false,
  },
  ChangePayload: {
    type: "object",
    properties: {
      summary: { type: "string", minLength: 10, maxLength: 5000 },
      requested_change: { type: "string", minLength: 1, maxLength: 10000 },
      document_ids: {
        type: "array",
        items: { type: "string", format: "uuid" },
        maxItems: 10,
      },
    },
    required: ["summary", "requested_change", "document_ids"],
    additionalProperties: false,
  },
  DeliveryPayload: {
    type: "object",
    properties: {
      summary: { type: "string", minLength: 1, maxLength: 5000 },
      occurred_at: { type: "string", format: "date-time" },
      document_ids: {
        type: "array",
        items: { type: "string", format: "uuid" },
        maxItems: 10,
      },
    },
    required: ["summary", "occurred_at", "document_ids"],
    additionalProperties: false,
  },
  ContractAction: {
    oneOf: [
      {
        type: "object",
        properties: {
          action_id: { type: "string", format: "uuid" },
          relationship_id: { type: "string", format: "uuid" },
          award_version_id: { type: "string", format: "uuid" },
          kind: { const: "acknowledgment" },
          state: {
            type: "string",
            enum: [
              "recorded",
              "submitted",
              "under_review",
              "accepted",
              "rejected",
              "withdrawn",
            ],
          },
          released_reason: {
            anyOf: [{ type: "string", maxLength: 5000 }, { type: "null" }],
          },
          created_at: { type: "string", format: "date-time" },
          version: { type: "integer", minimum: 1 },
          content: {
            type: "object",
            properties: { acknowledgment: { const: "ACKNOWLEDGE_RECEIPT" } },
            required: ["acknowledgment"],
            additionalProperties: false,
          },
        },
        required: [
          "action_id",
          "relationship_id",
          "award_version_id",
          "kind",
          "state",
          "released_reason",
          "created_at",
          "version",
          "content",
        ],
        additionalProperties: false,
      },
      {
        type: "object",
        properties: {
          action_id: { type: "string", format: "uuid" },
          relationship_id: { type: "string", format: "uuid" },
          award_version_id: { type: "string", format: "uuid" },
          kind: { const: "change_request" },
          state: {
            type: "string",
            enum: [
              "recorded",
              "submitted",
              "under_review",
              "accepted",
              "rejected",
              "withdrawn",
            ],
          },
          released_reason: {
            anyOf: [{ type: "string", maxLength: 5000 }, { type: "null" }],
          },
          created_at: { type: "string", format: "date-time" },
          version: { type: "integer", minimum: 1 },
          content: { $ref: "#/$defs/ChangePayload" },
        },
        required: [
          "action_id",
          "relationship_id",
          "award_version_id",
          "kind",
          "state",
          "released_reason",
          "created_at",
          "version",
          "content",
        ],
        additionalProperties: false,
      },
      {
        type: "object",
        properties: {
          action_id: { type: "string", format: "uuid" },
          relationship_id: { type: "string", format: "uuid" },
          award_version_id: { type: "string", format: "uuid" },
          kind: { const: "delivery_update" },
          state: {
            type: "string",
            enum: [
              "recorded",
              "submitted",
              "under_review",
              "accepted",
              "rejected",
              "withdrawn",
            ],
          },
          released_reason: {
            anyOf: [{ type: "string", maxLength: 5000 }, { type: "null" }],
          },
          created_at: { type: "string", format: "date-time" },
          version: { type: "integer", minimum: 1 },
          content: { $ref: "#/$defs/DeliveryPayload" },
        },
        required: [
          "action_id",
          "relationship_id",
          "award_version_id",
          "kind",
          "state",
          "released_reason",
          "created_at",
          "version",
          "content",
        ],
        additionalProperties: false,
      },
    ],
  },
  MetricDefinition: {
    type: "object",
    properties: {
      metric_key: { type: "string", minLength: 1, maxLength: 64 },
      label: { type: "string", minLength: 1, maxLength: 200 },
      unit_code: { type: "string", minLength: 1, maxLength: 200 },
      numerator_rule: { type: "string", minLength: 1, maxLength: 64 },
      denominator_rule: {
        anyOf: [
          { type: "string", minLength: 1, maxLength: 64 },
          { type: "null" },
        ],
      },
      target: { anyOf: [{ type: "number", minimum: 0 }, { type: "null" }] },
      roles: {
        type: "array",
        items: {
          type: "string",
          enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
        },
        maxItems: 3,
      },
    },
    required: [
      "metric_key",
      "label",
      "unit_code",
      "numerator_rule",
      "denominator_rule",
      "target",
      "roles",
    ],
    additionalProperties: false,
  },
  Metric: {
    type: "object",
    properties: {
      metric_key: { type: "string", minLength: 1, maxLength: 200 },
      definition_version: { type: "integer", minimum: 1 },
      numerator: { anyOf: [{ type: "number", minimum: 0 }, { type: "null" }] },
      denominator: {
        anyOf: [{ type: "number", minimum: 0 }, { type: "null" }],
      },
      value: { anyOf: [{ type: "number", minimum: 0 }, { type: "null" }] },
      unit_code: { type: "string", minLength: 1, maxLength: 200 },
      target: { anyOf: [{ type: "number", minimum: 0 }, { type: "null" }] },
      availability: {
        type: "string",
        enum: ["available", "no_data", "unavailable"],
      },
    },
    required: [
      "metric_key",
      "definition_version",
      "numerator",
      "denominator",
      "value",
      "unit_code",
      "target",
      "availability",
    ],
    additionalProperties: false,
  },
  Scorecard: {
    type: "object",
    properties: {
      relationship_id: { type: "string", format: "uuid" },
      award_version_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      configured: { type: "boolean" },
      released: { type: "boolean" },
      period_start: { type: "string", format: "date-time" },
      period_end: { type: "string", format: "date-time" },
      metrics: {
        type: "array",
        items: { $ref: "#/$defs/Metric" },
        maxItems: 50,
      },
      source_watermark: {
        anyOf: [{ type: "string", format: "date-time" }, { type: "null" }],
      },
    },
    required: [
      "relationship_id",
      "award_version_id",
      "configured",
      "released",
      "period_start",
      "period_end",
      "metrics",
      "source_watermark",
    ],
    additionalProperties: false,
  },
  VersionResult: {
    type: "object",
    properties: {
      id: { type: "string", format: "uuid" },
      version: { type: "integer", minimum: 1 },
      state: { type: "string", minLength: 1, maxLength: 200 },
    },
    required: ["id", "version", "state"],
    additionalProperties: false,
  },
  SuccessMeta: {
    type: "object",
    properties: { request_id: { type: "string", format: "uuid" } },
    required: ["request_id"],
    additionalProperties: false,
  },
  Error: {
    type: "object",
    properties: {
      ok: { const: false },
      error: {
        type: "object",
        properties: {
          code: {
            type: "string",
            enum: [
              "unauthenticated",
              "not_available",
              "permission_denied",
              "mfa_required",
              "step_up_required",
              "conflict",
              "invalid_input",
              "rate_limited",
              "policy_unconfigured",
              "temporary_failure",
            ],
          },
          message: { type: "string", minLength: 1, maxLength: 500 },
          request_id: { type: "string", format: "uuid" },
          retry_after_seconds: { type: "integer", minimum: 1, maximum: 86400 },
          required_action: {
            type: "string",
            enum: [
              "sign_in",
              "enroll_mfa",
              "challenge_mfa",
              "step_up",
              "retry",
              "contact_support",
            ],
          },
        },
        required: ["code", "message", "request_id"],
        additionalProperties: false,
      },
    },
    required: ["ok", "error"],
    additionalProperties: false,
  },
  IntakePolicy: {
    type: "object",
    properties: {
      relationship_id: { type: "string", format: "uuid" },
      configured: { type: "boolean" },
      policy_version_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      notice_text: {
        anyOf: [{ type: "string", maxLength: 20000 }, { type: "null" }],
      },
      required_attestation_text: {
        anyOf: [{ type: "string", maxLength: 5000 }, { type: "null" }],
      },
      retention_policy_label: {
        anyOf: [
          { type: "string", minLength: 1, maxLength: 200 },
          { type: "null" },
        ],
      },
      collection_allowed: { type: "boolean" },
    },
    required: [
      "relationship_id",
      "configured",
      "policy_version_id",
      "notice_text",
      "required_attestation_text",
      "retention_policy_label",
      "collection_allowed",
    ],
    additionalProperties: false,
  },
  NoticeReceipt: {
    type: "object",
    properties: {
      notice_receipt_id: { type: "string", format: "uuid" },
      relationship_id: { type: "string", format: "uuid" },
      share_id: { type: "string", format: "uuid" },
      policy_version_id: { type: "string", format: "uuid" },
      attested_by: { type: "string", format: "uuid" },
      recorded_at: { type: "string", format: "date-time" },
    },
    required: [
      "notice_receipt_id",
      "relationship_id",
      "share_id",
      "policy_version_id",
      "attested_by",
      "recorded_at",
    ],
    additionalProperties: false,
  },
  PartnerCompany: {
    type: "object",
    properties: {
      partner_org_id: { type: "string", format: "uuid" },
      name: { type: "string", minLength: 1, maxLength: 200 },
      status: { type: "string", enum: ["active", "suspended", "archived"] },
    },
    required: ["partner_org_id", "name", "status"],
    additionalProperties: false,
  },
  AwardPage: {
    type: "object",
    properties: {
      items: { type: "array", items: { $ref: "#/$defs/Award" }, maxItems: 100 },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  SharePage: {
    type: "object",
    properties: {
      items: { type: "array", items: { $ref: "#/$defs/Share" }, maxItems: 100 },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  RatePage: {
    type: "object",
    properties: {
      items: { type: "array", items: { $ref: "#/$defs/Rate" }, maxItems: 100 },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  SubmissionPage: {
    type: "object",
    properties: {
      items: {
        type: "array",
        items: { $ref: "#/$defs/Submission" },
        maxItems: 100,
      },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  DocumentPage: {
    type: "object",
    properties: {
      items: {
        type: "array",
        items: { $ref: "#/$defs/Document" },
        maxItems: 100,
      },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  ContractActionPage: {
    type: "object",
    properties: {
      items: {
        type: "array",
        items: { $ref: "#/$defs/ContractAction" },
        maxItems: 100,
      },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  MembershipPage: {
    type: "object",
    properties: {
      items: {
        type: "array",
        items: { $ref: "#/$defs/Membership" },
        maxItems: 100,
      },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  InvitationPage: {
    type: "object",
    properties: {
      items: {
        type: "array",
        items: { $ref: "#/$defs/Invitation" },
        maxItems: 100,
      },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  Contexts: {
    type: "object",
    properties: {
      contexts: {
        type: "array",
        items: { $ref: "#/$defs/Context" },
        maxItems: 100,
      },
    },
    required: ["contexts"],
    additionalProperties: false,
  },
  RelationshipPage: {
    type: "object",
    properties: {
      items: {
        type: "array",
        items: { $ref: "#/$defs/Relationship" },
        maxItems: 100,
      },
      next_cursor: {
        anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
      },
    },
    required: ["items", "next_cursor"],
    additionalProperties: false,
  },
  SetupResult: {
    type: "object",
    properties: {
      relationship_id: { type: "string", format: "uuid" },
      state: {
        type: "string",
        enum: ["password_setup", "mfa_enrollment", "mfa_challenge", "ready"],
      },
      version: { type: "integer", minimum: 1 },
    },
    required: ["relationship_id", "state", "version"],
    additionalProperties: false,
  },
  PrimeSourceSubcontractors: {
    type: "object",
    properties: {
      id: { type: "string", format: "uuid" },
      name: { type: "string", minLength: 1, maxLength: 200 },
      status: { type: "string", minLength: 1, maxLength: 32 },
    },
    required: ["id", "name", "status"],
    additionalProperties: false,
  },
  PrimeSourcePartnerCompanies: {
    type: "object",
    properties: {
      partner_org_id: { type: "string", format: "uuid" },
      name: { type: "string", minLength: 1, maxLength: 200 },
      status: { enum: ["active", "suspended", "archived"] },
    },
    required: ["partner_org_id", "name", "status"],
    additionalProperties: false,
  },
  PrimeSourceVendorOrders: {
    type: "object",
    properties: {
      id: { type: "string", format: "uuid" },
      to_number: { type: "string", minLength: 1, maxLength: 200 },
      title: { type: "string", minLength: 1, maxLength: 200 },
      contract_id: { type: "string", format: "uuid" },
      customer_task_order_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
      status: { type: "string", minLength: 1, maxLength: 32 },
      updated_at: { type: "string", format: "date-time" },
    },
    required: [
      "id",
      "to_number",
      "title",
      "contract_id",
      "customer_task_order_id",
      "status",
      "updated_at",
    ],
    additionalProperties: false,
  },
  PrimeSourceRequisitions: {
    type: "object",
    properties: {
      id: { type: "string", format: "uuid" },
      title: { type: "string", minLength: 1, maxLength: 200 },
      status: { enum: ["approved", "sourcing"] },
      version: { type: "integer", minimum: 1 },
      updated_at: { type: "string", format: "date-time" },
      labor_category_id: {
        anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
      },
    },
    required: [
      "id",
      "title",
      "status",
      "version",
      "updated_at",
      "labor_category_id",
    ],
    additionalProperties: false,
  },
  PrimeSourceLaborCategories: {
    type: "object",
    properties: {
      id: { type: "string", format: "uuid" },
      title: { type: "string", minLength: 1, maxLength: 200 },
    },
    required: ["id", "title"],
    additionalProperties: false,
  },
  PrimePartnerSourceOptions: {
    oneOf: [
      {
        type: "object",
        properties: {
          kind: { const: "subcontractors" },
          items: {
            type: "array",
            maxItems: 100,
            items: { $ref: "#/$defs/PrimeSourceSubcontractors" },
          },
          next_cursor: {
            anyOf: [
              { type: "string", minLength: 1, maxLength: 2048 },
              { type: "null" },
            ],
          },
        },
        required: ["kind", "items", "next_cursor"],
        additionalProperties: false,
      },
      {
        type: "object",
        properties: {
          kind: { const: "partner_companies" },
          items: {
            type: "array",
            maxItems: 100,
            items: { $ref: "#/$defs/PrimeSourcePartnerCompanies" },
          },
          next_cursor: {
            anyOf: [
              { type: "string", minLength: 1, maxLength: 2048 },
              { type: "null" },
            ],
          },
        },
        required: ["kind", "items", "next_cursor"],
        additionalProperties: false,
      },
      {
        type: "object",
        properties: {
          kind: { const: "vendor_orders" },
          items: {
            type: "array",
            maxItems: 100,
            items: { $ref: "#/$defs/PrimeSourceVendorOrders" },
          },
          next_cursor: {
            anyOf: [
              { type: "string", minLength: 1, maxLength: 2048 },
              { type: "null" },
            ],
          },
        },
        required: ["kind", "items", "next_cursor"],
        additionalProperties: false,
      },
      {
        type: "object",
        properties: {
          kind: { const: "requisitions" },
          items: {
            type: "array",
            maxItems: 100,
            items: { $ref: "#/$defs/PrimeSourceRequisitions" },
          },
          next_cursor: {
            anyOf: [
              { type: "string", minLength: 1, maxLength: 2048 },
              { type: "null" },
            ],
          },
        },
        required: ["kind", "items", "next_cursor"],
        additionalProperties: false,
      },
      {
        type: "object",
        properties: {
          kind: { const: "labor_categories" },
          items: {
            type: "array",
            maxItems: 100,
            items: { $ref: "#/$defs/PrimeSourceLaborCategories" },
          },
          next_cursor: {
            anyOf: [
              { type: "string", minLength: 1, maxLength: 2048 },
              { type: "null" },
            ],
          },
        },
        required: ["kind", "items", "next_cursor"],
        additionalProperties: false,
      },
    ],
  },
};
const operations: Record<
  PartnerOperation,
  { path: string; request: Schema; response: Schema }
> = {
  get_my_partner_contexts: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: { action: { const: "get_my_partner_contexts" } },
      required: ["action"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Contexts" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  provision_partner_company: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "provision_partner_company" },
        prime_org_id: { type: "string", format: "uuid" },
        name: { type: "string", minLength: 1, maxLength: 200 },
        time_zone: { type: "string", minLength: 1, maxLength: 200 },
        linkage_attestation: { type: "string", minLength: 10, maxLength: 1000 },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "prime_org_id",
        "name",
        "time_zone",
        "linkage_attestation",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/PartnerCompany" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  create_partner_relationship: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "create_partner_relationship" },
        prime_org_id: { type: "string", format: "uuid" },
        partner_org_id: { type: "string", format: "uuid" },
        subcontractor_id: { type: "string", format: "uuid" },
        linkage_attestation: { type: "string", minLength: 10, maxLength: 1000 },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "prime_org_id",
        "partner_org_id",
        "subcontractor_id",
        "linkage_attestation",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Relationship" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  set_partner_relationship_state: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "set_partner_relationship_state" },
        relationship_id: { type: "string", format: "uuid" },
        state: { type: "string", enum: ["active", "suspended", "revoked"] },
        reason: { type: "string", maxLength: 5000 },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "state",
        "reason",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Relationship" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  invite_partner_user: {
    path: "/functions/v1/partner-invitations",
    request: {
      type: "object",
      properties: {
        action: { const: "invite_partner_user" },
        relationship_id: { type: "string", format: "uuid" },
        email: { type: "string", format: "email", maxLength: 320 },
        role: {
          type: "string",
          enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
        },
        capabilities: {
          type: "array",
          items: {
            type: "string",
            enum: [
              "users.manage",
              "work.read",
              "recruiting.read",
              "recruiting.write",
              "documents.read",
              "documents.upload",
              "contracts.request",
              "delivery.write",
              "scorecards.read",
            ],
          },
          maxItems: 9,
        },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "email",
        "role",
        "capabilities",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Invitation" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  accept_partner_invitation: {
    path: "/functions/v1/partner-invitations",
    request: {
      type: "object",
      properties: {
        action: { const: "accept_partner_invitation" },
        opaque_token: { type: "string", minLength: 43, maxLength: 256 },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: ["action", "opaque_token", "idempotency_key"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Membership" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  resend_partner_invitation: {
    path: "/functions/v1/partner-invitations",
    request: {
      type: "object",
      properties: {
        action: { const: "resend_partner_invitation" },
        relationship_id: { type: "string", format: "uuid" },
        invitation_id: { type: "string", format: "uuid" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "invitation_id",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Invitation" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  revoke_partner_invitation: {
    path: "/functions/v1/partner-invitations",
    request: {
      type: "object",
      properties: {
        action: { const: "revoke_partner_invitation" },
        relationship_id: { type: "string", format: "uuid" },
        invitation_id: { type: "string", format: "uuid" },
        reason: { type: "string", maxLength: 5000 },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "invitation_id",
        "reason",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Invitation" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_invitations: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_invitations" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
      },
      required: ["action", "relationship_id", "cursor", "page_size"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/InvitationPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_memberships: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_memberships" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
      },
      required: ["action", "relationship_id", "cursor", "page_size"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/MembershipPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  set_partner_membership: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "set_partner_membership" },
        relationship_id: { type: "string", format: "uuid" },
        membership_id: { type: "string", format: "uuid" },
        role: {
          type: "string",
          enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
        },
        capabilities: {
          type: "array",
          items: {
            type: "string",
            enum: [
              "users.manage",
              "work.read",
              "recruiting.read",
              "recruiting.write",
              "documents.read",
              "documents.upload",
              "contracts.request",
              "delivery.write",
              "scorecards.read",
            ],
          },
          maxItems: 9,
        },
        state: { type: "string", enum: ["active", "suspended", "revoked"] },
        replacement_administrator_membership_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
        award_access: {
          type: "array",
          maxItems: 100,
          items: {
            type: "object",
            properties: {
              award_version_id: { type: "string", format: "uuid" },
              delivery_write: { type: "boolean" },
              delivery_document_upload: { type: "boolean" },
            },
            required: [
              "award_version_id",
              "delivery_write",
              "delivery_document_upload",
            ],
            additionalProperties: false,
          },
        },
      },
      required: [
        "action",
        "relationship_id",
        "membership_id",
        "role",
        "capabilities",
        "state",
        "replacement_administrator_membership_id",
        "idempotency_key",
        "expected_version",
        "award_access",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Membership" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  publish_partner_award: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "publish_partner_award" },
        relationship_id: { type: "string", format: "uuid" },
        vendor_order_id: { type: "string", format: "uuid" },
        contract_id: { type: "string", format: "uuid" },
        customer_task_order_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
        terms: { $ref: "#/$defs/AwardTerms" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_vendor_order_updated_at: {
          type: "string",
          format: "date-time",
        },
      },
      required: [
        "action",
        "relationship_id",
        "vendor_order_id",
        "contract_id",
        "customer_task_order_id",
        "terms",
        "idempotency_key",
        "expected_vendor_order_updated_at",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Award" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_awards: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_awards" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
      },
      required: ["action", "relationship_id", "cursor", "page_size"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/AwardPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  publish_partner_rate: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "publish_partner_rate" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: { type: "string", format: "uuid" },
        terms: { $ref: "#/$defs/RateInput" },
        idempotency_key: { type: "string", format: "uuid" },
        visible_to_roles: {
          type: "array",
          items: {
            type: "string",
            enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
          },
          maxItems: 3,
          uniqueItems: true,
        },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "terms",
        "idempotency_key",
        "visible_to_roles",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Rate" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  retire_partner_rate: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "retire_partner_rate" },
        relationship_id: { type: "string", format: "uuid" },
        rate_schedule_version_id: { type: "string", format: "uuid" },
        reason: { type: "string", maxLength: 5000 },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "rate_schedule_version_id",
        "reason",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Rate" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  share_partner_requisition: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "share_partner_requisition" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: { type: "string", format: "uuid" },
        requisition_id: { type: "string", format: "uuid" },
        source_requisition_version: { type: "integer", minimum: 1 },
        requirements: { $ref: "#/$defs/RequisitionProjection" },
        rate_schedule_version_id: { type: "string", format: "uuid" },
        idempotency_key: { type: "string", format: "uuid" },
        visible_to_roles: {
          type: "array",
          items: {
            type: "string",
            enum: ["partner_admin", "partner_recruiter", "partner_viewer"],
          },
          maxItems: 3,
          uniqueItems: true,
        },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "requisition_id",
        "source_requisition_version",
        "requirements",
        "rate_schedule_version_id",
        "idempotency_key",
        "visible_to_roles",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Share" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  revoke_partner_requisition_share: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "revoke_partner_requisition_share" },
        relationship_id: { type: "string", format: "uuid" },
        share_id: { type: "string", format: "uuid" },
        reason: { type: "string", maxLength: 5000 },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "share_id",
        "reason",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Share" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_requisitions: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_requisitions" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
      },
      required: ["action", "relationship_id", "cursor", "page_size"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/SharePage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_intake_policy: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_intake_policy" },
        relationship_id: { type: "string", format: "uuid" },
      },
      required: ["action", "relationship_id"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/IntakePolicy" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  attest_partner_candidate_notice: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "attest_partner_candidate_notice" },
        relationship_id: { type: "string", format: "uuid" },
        share_id: { type: "string", format: "uuid" },
        policy_version_id: { type: "string", format: "uuid" },
        attested: { const: true },
        evidence_reference: {
          anyOf: [{ type: "string", maxLength: 500 }, { type: "null" }],
        },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "share_id",
        "policy_version_id",
        "attested",
        "evidence_reference",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/NoticeReceipt" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  create_partner_submission_draft: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "create_partner_submission_draft" },
        relationship_id: { type: "string", format: "uuid" },
        share_id: { type: "string", format: "uuid" },
        candidate: { $ref: "#/$defs/CandidateInput" },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "share_id",
        "candidate",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Submission" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  update_partner_submission_draft: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "update_partner_submission_draft" },
        relationship_id: { type: "string", format: "uuid" },
        submission_id: { type: "string", format: "uuid" },
        candidate: { $ref: "#/$defs/CandidateInput" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "submission_id",
        "candidate",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Submission" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  submit_partner_candidate: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "submit_partner_candidate" },
        relationship_id: { type: "string", format: "uuid" },
        submission_id: { type: "string", format: "uuid" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "submission_id",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Submission" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  withdraw_partner_candidate: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "withdraw_partner_candidate" },
        relationship_id: { type: "string", format: "uuid" },
        submission_id: { type: "string", format: "uuid" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "submission_id",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Submission" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_submissions: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_submissions" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
        share_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
      },
      required: [
        "action",
        "relationship_id",
        "cursor",
        "page_size",
        "share_id",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/SubmissionPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  publish_partner_candidate_decision: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "publish_partner_candidate_decision" },
        relationship_id: { type: "string", format: "uuid" },
        submission_id: { type: "string", format: "uuid" },
        pipeline_status: {
          type: "string",
          enum: [
            "applied",
            "screening",
            "submitted_to_client",
            "interviewed",
            "offered",
            "placed",
            "rejected",
            "withdrawn",
          ],
        },
        released_reason: {
          anyOf: [{ type: "string", maxLength: 5000 }, { type: "null" }],
        },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "submission_id",
        "pipeline_status",
        "released_reason",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Submission" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  release_partner_document: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "release_partner_document" },
        relationship_id: { type: "string", format: "uuid" },
        document_id: { type: "string", format: "uuid" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "document_id",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Document" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  revoke_partner_document: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "revoke_partner_document" },
        relationship_id: { type: "string", format: "uuid" },
        document_id: { type: "string", format: "uuid" },
        reason: { type: "string", maxLength: 5000 },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "document_id",
        "reason",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Document" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_documents: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_documents" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
        parent_kind: { type: "string", enum: ["submission", "award_version"] },
        parent_id: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "cursor",
        "page_size",
        "parent_kind",
        "parent_id",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/DocumentPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  acknowledge_partner_award: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "acknowledge_partner_award" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: { type: "string", format: "uuid" },
        acknowledgment: { const: "ACKNOWLEDGE_RECEIPT" },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "acknowledgment",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/ContractAction" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  request_partner_contract_change: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "request_partner_contract_change" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: { type: "string", format: "uuid" },
        request: { $ref: "#/$defs/ChangePayload" },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "request",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/ContractAction" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  withdraw_partner_contract_change: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "withdraw_partner_contract_change" },
        relationship_id: { type: "string", format: "uuid" },
        action_id: { type: "string", format: "uuid" },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "action_id",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/ContractAction" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  resolve_partner_contract_change: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "resolve_partner_contract_change" },
        relationship_id: { type: "string", format: "uuid" },
        action_id: { type: "string", format: "uuid" },
        decision: {
          type: "string",
          enum: ["under_review", "accepted", "rejected"],
        },
        released_reason: { type: "string", maxLength: 5000 },
        new_award_version_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
        idempotency_key: { type: "string", format: "uuid" },
        expected_version: { type: "integer", minimum: 1 },
      },
      required: [
        "action",
        "relationship_id",
        "action_id",
        "decision",
        "released_reason",
        "new_award_version_id",
        "idempotency_key",
        "expected_version",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/ContractAction" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  append_partner_delivery_update: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "append_partner_delivery_update" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: { type: "string", format: "uuid" },
        update: { $ref: "#/$defs/DeliveryPayload" },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "update",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/ContractAction" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_contract_actions: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_contract_actions" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
        award_version_id: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "cursor",
        "page_size",
        "award_version_id",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/ContractActionPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  publish_partner_scorecard: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "publish_partner_scorecard" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
        period_start: { type: "string", format: "date-time" },
        period_end: { type: "string", format: "date-time" },
        definitions: {
          type: "array",
          items: { $ref: "#/$defs/MetricDefinition" },
          maxItems: 50,
        },
        policy_version: { type: "integer", minimum: 1 },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "period_start",
        "period_end",
        "definitions",
        "policy_version",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Scorecard" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_scorecard: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_scorecard" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
        period_start: { type: "string", format: "date-time" },
        period_end: { type: "string", format: "date-time" },
      },
      required: [
        "action",
        "relationship_id",
        "award_version_id",
        "period_start",
        "period_end",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/Scorecard" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  list_partner_scorecard_releases: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "list_partner_scorecard_releases" },
        relationship_id: { type: "string", format: "uuid" },
        award_version_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
      },
      required: ["action", "relationship_id", "award_version_id"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: {
          type: "object",
          properties: {
            relationship_id: { type: "string", format: "uuid" },
            award_version_id: {
              anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
            },
            periods: {
              type: "array",
              maxItems: 24,
              items: {
                type: "object",
                properties: {
                  period_start: { type: "string", format: "date-time" },
                  period_end: { type: "string", format: "date-time" },
                  released_at: { type: "string", format: "date-time" },
                  metrics: {
                    type: "array",
                    maxItems: 50,
                    items: {
                      type: "object",
                      properties: {
                                metric_key: { type: "string", minLength: 1, maxLength: 200 },
                                label: { type: "string", minLength: 1, maxLength: 200 },
                                definition_version: { type: "integer", minimum: 1 },
                                numerator: {
                                  anyOf: [{ type: "number", minimum: 0 }, { type: "null" }],
                                },
                                denominator: {
                                  anyOf: [{ type: "number", minimum: 0 }, { type: "null" }],
                                },
                                value: {
                                  anyOf: [{ type: "number", minimum: 0 }, { type: "null" }],
                                },
                                unit_code: { type: "string", minLength: 1, maxLength: 200 },
                                target: {
                                  anyOf: [{ type: "number", minimum: 0 }, { type: "null" }],
                                },
                                availability: {
                                  type: "string",
                                  enum: ["available", "no_data", "unavailable"],
                                },
                              },
                      required: [
                        "metric_key",
                        "label",
                        "definition_version",
                        "numerator",
                        "denominator",
                        "value",
                        "unit_code",
                        "target",
                        "availability",
                      ],
                      additionalProperties: false,
                    },
                  },
                },
                required: ["period_start", "period_end", "released_at", "metrics"],
                additionalProperties: false,
              },
            },
          },
          required: ["relationship_id", "award_version_id", "periods"],
          additionalProperties: false,
        },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_scorecard_setup: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: {
          const: "get_partner_scorecard_setup"
        },
        relationship_id: {
          type: "string",
          format: "uuid"
        },
        period_start: {
          type: "string",
          format: "date-time"
        }
      },
      required: [
        "action",
        "relationship_id",
        "period_start"
      ],
      additionalProperties: false
    },
    response: {
      type: "object",
      properties: {
        ok: {
          const: true
        },
        data: {
          type: "object",
          properties: {
            relationship_id: {
              type: "string",
              format: "uuid"
            },
            period_start: {
              type: "string",
              format: "date-time"
            },
            period_end: {
              type: "string",
              format: "date-time"
            },
            state: {
              type: "string",
              enum: [
                "not_set_up",
                "ready",
                "published"
              ]
            },
            version: {
              type: "integer",
              minimum: 0
            },
            carried_over: {
              type: "boolean"
            },
            last_period: {
              anyOf: [
                {
                  type: "object",
                  properties: {
                    period_start: {
                      type: "string",
                      format: "date-time"
                    },
                    period_end: {
                      type: "string",
                      format: "date-time"
                    }
                  },
                  required: [
                    "period_start",
                    "period_end"
                  ],
                  additionalProperties: false
                },
                {
                  type: "null"
                }
              ]
            },
            released_at: {
              anyOf: [
                {
                  type: "string",
                  format: "date-time"
                },
                {
                  type: "null"
                }
              ]
            },
            policy_version: {
              anyOf: [
                {
                  type: "integer",
                  minimum: 1
                },
                {
                  type: "null"
                }
              ]
            },
            definitions: {
              type: "array",
              items: {
                $ref: "#/$defs/MetricDefinition"
              },
              maxItems: 50
            },
            measures: {
              type: "array",
              maxItems: 7,
              items: {
                type: "object",
                properties: {
                  measure_key: {
                    type: "string",
                    minLength: 1,
                    maxLength: 64
                  },
                  label: {
                    type: "string",
                    minLength: 1,
                    maxLength: 200
                  },
                  explanation: {
                    type: "string",
                    minLength: 1,
                    maxLength: 400
                  },
                  unit_code: {
                    type: "string",
                    minLength: 1,
                    maxLength: 200
                  },
                  selected: {
                    type: "boolean"
                  },
                  needs_deliverables: {
                    type: "boolean"
                  },
                  record_count: {
                    anyOf: [
                      {
                        type: "integer",
                        minimum: 0
                      },
                      {
                        type: "null"
                      }
                    ]
                  }
                },
                required: [
                  "measure_key",
                  "label",
                  "explanation",
                  "unit_code",
                  "selected",
                  "needs_deliverables",
                  "record_count"
                ],
                additionalProperties: false
              }
            },
            excluded_positions: {
              type: "integer",
              minimum: 0
            },
            excluded_shared_deliverables: {
              type: "integer",
              minimum: 0
            },
            deliverables: {
              type: "array",
              maxItems: 200,
              items: {
                type: "object",
                properties: {
                  deliverable_id: {
                    type: "string",
                    format: "uuid"
                  },
                  title: {
                    type: "string",
                    minLength: 1,
                    maxLength: 200
                  },
                  due_date: {
                    type: "string",
                    format: "date"
                  },
                  status: {
                    type: "string",
                    minLength: 1,
                    maxLength: 40
                  },
                  selected: {
                    type: "boolean"
                  }
                },
                required: [
                  "deliverable_id",
                  "title",
                  "due_date",
                  "status",
                  "selected"
                ],
                additionalProperties: false
              }
            },
            deliverables_truncated: {
              type: "boolean"
            }
          },
          required: [
            "relationship_id",
            "period_start",
            "period_end",
            "state",
            "version",
            "carried_over",
            "last_period",
            "released_at",
            "policy_version",
            "definitions",
            "measures",
            "excluded_positions",
            "deliverables",
            "deliverables_truncated"
          ],
          additionalProperties: false
        },
        meta: {
          $ref: "#/$defs/SuccessMeta"
        }
      },
      required: [
        "ok",
        "data",
        "meta"
      ],
      additionalProperties: false
    }
  },
  save_partner_scorecard_setup: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: {
          const: "save_partner_scorecard_setup"
        },
        relationship_id: {
          type: "string",
          format: "uuid"
        },
        period_start: {
          type: "string",
          format: "date-time"
        },
        measures: {
          type: "array",
          maxItems: 7,
          uniqueItems: true,
          items: {
            type: "string",
            enum: [
              "on_time_deliverables",
              "staffing_coverage",
              "fill_rate",
              "retained_placements",
              "submissions",
              "decisions",
              "qualified_submissions"
            ]
          }
        },
        deliverable_ids: {
          type: "array",
          maxItems: 200,
          uniqueItems: true,
          items: {
            type: "string",
            format: "uuid"
          }
        },
        expected_version: {
          type: "integer",
          minimum: 0
        },
        idempotency_key: {
          type: "string",
          format: "uuid"
        }
      },
      required: [
        "action",
        "relationship_id",
        "period_start",
        "measures",
        "deliverable_ids",
        "expected_version",
        "idempotency_key"
      ],
      additionalProperties: false
    },
    response: {
      type: "object",
      properties: {
        ok: {
          const: true
        },
        data: {
          type: "object",
          properties: {
            relationship_id: {
              type: "string",
              format: "uuid"
            },
            period_start: {
              type: "string",
              format: "date-time"
            },
            period_end: {
              type: "string",
              format: "date-time"
            },
            state: {
              type: "string",
              enum: [
                "not_set_up",
                "ready",
                "published"
              ]
            },
            version: {
              type: "integer",
              minimum: 0
            },
            carried_over: {
              type: "boolean"
            },
            last_period: {
              anyOf: [
                {
                  type: "object",
                  properties: {
                    period_start: {
                      type: "string",
                      format: "date-time"
                    },
                    period_end: {
                      type: "string",
                      format: "date-time"
                    }
                  },
                  required: [
                    "period_start",
                    "period_end"
                  ],
                  additionalProperties: false
                },
                {
                  type: "null"
                }
              ]
            },
            released_at: {
              anyOf: [
                {
                  type: "string",
                  format: "date-time"
                },
                {
                  type: "null"
                }
              ]
            },
            policy_version: {
              anyOf: [
                {
                  type: "integer",
                  minimum: 1
                },
                {
                  type: "null"
                }
              ]
            },
            definitions: {
              type: "array",
              items: {
                $ref: "#/$defs/MetricDefinition"
              },
              maxItems: 50
            },
            measures: {
              type: "array",
              maxItems: 7,
              items: {
                type: "object",
                properties: {
                  measure_key: {
                    type: "string",
                    minLength: 1,
                    maxLength: 64
                  },
                  label: {
                    type: "string",
                    minLength: 1,
                    maxLength: 200
                  },
                  explanation: {
                    type: "string",
                    minLength: 1,
                    maxLength: 400
                  },
                  unit_code: {
                    type: "string",
                    minLength: 1,
                    maxLength: 200
                  },
                  selected: {
                    type: "boolean"
                  },
                  needs_deliverables: {
                    type: "boolean"
                  },
                  record_count: {
                    anyOf: [
                      {
                        type: "integer",
                        minimum: 0
                      },
                      {
                        type: "null"
                      }
                    ]
                  }
                },
                required: [
                  "measure_key",
                  "label",
                  "explanation",
                  "unit_code",
                  "selected",
                  "needs_deliverables",
                  "record_count"
                ],
                additionalProperties: false
              }
            },
            excluded_positions: {
              type: "integer",
              minimum: 0
            },
            excluded_shared_deliverables: {
              type: "integer",
              minimum: 0
            },
            deliverables: {
              type: "array",
              maxItems: 200,
              items: {
                type: "object",
                properties: {
                  deliverable_id: {
                    type: "string",
                    format: "uuid"
                  },
                  title: {
                    type: "string",
                    minLength: 1,
                    maxLength: 200
                  },
                  due_date: {
                    type: "string",
                    format: "date"
                  },
                  status: {
                    type: "string",
                    minLength: 1,
                    maxLength: 40
                  },
                  selected: {
                    type: "boolean"
                  }
                },
                required: [
                  "deliverable_id",
                  "title",
                  "due_date",
                  "status",
                  "selected"
                ],
                additionalProperties: false
              }
            },
            deliverables_truncated: {
              type: "boolean"
            }
          },
          required: [
            "relationship_id",
            "period_start",
            "period_end",
            "state",
            "version",
            "carried_over",
            "last_period",
            "released_at",
            "policy_version",
            "definitions",
            "measures",
            "excluded_positions",
            "deliverables",
            "deliverables_truncated"
          ],
          additionalProperties: false
        },
        meta: {
          $ref: "#/$defs/SuccessMeta"
        }
      },
      required: [
        "ok",
        "data",
        "meta"
      ],
      additionalProperties: false
    }
  },
  get_prime_partner_relationships: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_prime_partner_relationships" },
        prime_org_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
      },
      required: ["action", "prime_org_id", "cursor", "page_size"],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/RelationshipPage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_partner_rates: {
    path: "/functions/v1/partner-api",
    request: {
      type: "object",
      properties: {
        action: { const: "get_partner_rates" },
        relationship_id: { type: "string", format: "uuid" },
        cursor: {
          anyOf: [{ type: "string", maxLength: 2000 }, { type: "null" }],
        },
        page_size: { type: "integer", minimum: 1, maximum: 100 },
        award_version_id: {
          anyOf: [{ type: "string", format: "uuid" }, { type: "null" }],
        },
      },
      required: [
        "action",
        "relationship_id",
        "cursor",
        "page_size",
        "award_version_id",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/RatePage" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  set_partner_initial_password: {
    path: "/functions/v1/partner-invitations",
    request: {
      type: "object",
      properties: {
        action: { const: "set_partner_initial_password" },
        relationship_id: { type: "string", format: "uuid" },
        password: { type: "string", minLength: 10, maxLength: 128 },
        expected_version: { type: "integer", minimum: 1 },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "password",
        "expected_version",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/SetupResult" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  complete_partner_setup: {
    path: "/functions/v1/partner-invitations",
    request: {
      type: "object",
      properties: {
        action: { const: "complete_partner_setup" },
        relationship_id: { type: "string", format: "uuid" },
        method: { type: "string", enum: ["password", "google", "github"] },
        expected_version: { type: "integer", minimum: 1 },
        idempotency_key: { type: "string", format: "uuid" },
      },
      required: [
        "action",
        "relationship_id",
        "method",
        "expected_version",
        "idempotency_key",
      ],
      additionalProperties: false,
    },
    response: {
      type: "object",
      properties: {
        ok: { const: true },
        data: { $ref: "#/$defs/SetupResult" },
        meta: { $ref: "#/$defs/SuccessMeta" },
      },
      required: ["ok", "data", "meta"],
      additionalProperties: false,
    },
  },
  get_prime_partner_source_options: {
    path: "/functions/v1/partner-api",
    request: {
      oneOf: [
        {
          type: "object",
          properties: {
            action: { const: "get_prime_partner_source_options" },
            prime_org_id: { type: "string", format: "uuid" },
            relationship_id: { type: "null" },
            award_version_id: { type: "null" },
            kind: { const: "subcontractors" },
            cursor: {
              anyOf: [
                { type: "string", minLength: 1, maxLength: 2048 },
                { type: "null" },
              ],
            },
            page_size: { type: "integer", minimum: 1, maximum: 100 },
          },
          required: [
            "action",
            "prime_org_id",
            "relationship_id",
            "award_version_id",
            "kind",
            "cursor",
            "page_size",
          ],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            action: { const: "get_prime_partner_source_options" },
            prime_org_id: { type: "string", format: "uuid" },
            relationship_id: { type: "null" },
            award_version_id: { type: "null" },
            kind: { const: "partner_companies" },
            cursor: {
              anyOf: [
                { type: "string", minLength: 1, maxLength: 2048 },
                { type: "null" },
              ],
            },
            page_size: { type: "integer", minimum: 1, maximum: 100 },
          },
          required: [
            "action",
            "prime_org_id",
            "relationship_id",
            "award_version_id",
            "kind",
            "cursor",
            "page_size",
          ],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            action: { const: "get_prime_partner_source_options" },
            prime_org_id: { type: "string", format: "uuid" },
            relationship_id: { type: "string", format: "uuid" },
            award_version_id: { type: "null" },
            kind: { const: "vendor_orders" },
            cursor: {
              anyOf: [
                { type: "string", minLength: 1, maxLength: 2048 },
                { type: "null" },
              ],
            },
            page_size: { type: "integer", minimum: 1, maximum: 100 },
          },
          required: [
            "action",
            "prime_org_id",
            "relationship_id",
            "award_version_id",
            "kind",
            "cursor",
            "page_size",
          ],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            action: { const: "get_prime_partner_source_options" },
            prime_org_id: { type: "string", format: "uuid" },
            relationship_id: { type: "string", format: "uuid" },
            award_version_id: { type: "string", format: "uuid" },
            kind: { const: "requisitions" },
            cursor: {
              anyOf: [
                { type: "string", minLength: 1, maxLength: 2048 },
                { type: "null" },
              ],
            },
            page_size: { type: "integer", minimum: 1, maximum: 100 },
          },
          required: [
            "action",
            "prime_org_id",
            "relationship_id",
            "award_version_id",
            "kind",
            "cursor",
            "page_size",
          ],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            action: { const: "get_prime_partner_source_options" },
            prime_org_id: { type: "string", format: "uuid" },
            relationship_id: { type: "string", format: "uuid" },
            award_version_id: { type: "string", format: "uuid" },
            kind: { const: "labor_categories" },
            cursor: {
              anyOf: [
                { type: "string", minLength: 1, maxLength: 2048 },
                { type: "null" },
              ],
            },
            page_size: { type: "integer", minimum: 1, maximum: 100 },
          },
          required: [
            "action",
            "prime_org_id",
            "relationship_id",
            "award_version_id",
            "kind",
            "cursor",
            "page_size",
          ],
          additionalProperties: false,
        },
      ],
    },
    response: {
      oneOf: [
        {
          type: "object",
          properties: {
            ok: { const: true },
            data: {
              type: "object",
              properties: {
                kind: { const: "subcontractors" },
                items: {
                  type: "array",
                  maxItems: 100,
                  items: { $ref: "#/$defs/PrimeSourceSubcontractors" },
                },
                next_cursor: {
                  anyOf: [
                    { type: "string", minLength: 1, maxLength: 2048 },
                    { type: "null" },
                  ],
                },
              },
              required: ["kind", "items", "next_cursor"],
              additionalProperties: false,
            },
            meta: { $ref: "#/$defs/SuccessMeta" },
          },
          required: ["ok", "data", "meta"],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            ok: { const: true },
            data: {
              type: "object",
              properties: {
                kind: { const: "partner_companies" },
                items: {
                  type: "array",
                  maxItems: 100,
                  items: { $ref: "#/$defs/PrimeSourcePartnerCompanies" },
                },
                next_cursor: {
                  anyOf: [
                    { type: "string", minLength: 1, maxLength: 2048 },
                    { type: "null" },
                  ],
                },
              },
              required: ["kind", "items", "next_cursor"],
              additionalProperties: false,
            },
            meta: { $ref: "#/$defs/SuccessMeta" },
          },
          required: ["ok", "data", "meta"],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            ok: { const: true },
            data: {
              type: "object",
              properties: {
                kind: { const: "vendor_orders" },
                items: {
                  type: "array",
                  maxItems: 100,
                  items: { $ref: "#/$defs/PrimeSourceVendorOrders" },
                },
                next_cursor: {
                  anyOf: [
                    { type: "string", minLength: 1, maxLength: 2048 },
                    { type: "null" },
                  ],
                },
              },
              required: ["kind", "items", "next_cursor"],
              additionalProperties: false,
            },
            meta: { $ref: "#/$defs/SuccessMeta" },
          },
          required: ["ok", "data", "meta"],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            ok: { const: true },
            data: {
              type: "object",
              properties: {
                kind: { const: "requisitions" },
                items: {
                  type: "array",
                  maxItems: 100,
                  items: { $ref: "#/$defs/PrimeSourceRequisitions" },
                },
                next_cursor: {
                  anyOf: [
                    { type: "string", minLength: 1, maxLength: 2048 },
                    { type: "null" },
                  ],
                },
              },
              required: ["kind", "items", "next_cursor"],
              additionalProperties: false,
            },
            meta: { $ref: "#/$defs/SuccessMeta" },
          },
          required: ["ok", "data", "meta"],
          additionalProperties: false,
        },
        {
          type: "object",
          properties: {
            ok: { const: true },
            data: {
              type: "object",
              properties: {
                kind: { const: "labor_categories" },
                items: {
                  type: "array",
                  maxItems: 100,
                  items: { $ref: "#/$defs/PrimeSourceLaborCategories" },
                },
                next_cursor: {
                  anyOf: [
                    { type: "string", minLength: 1, maxLength: 2048 },
                    { type: "null" },
                  ],
                },
              },
              required: ["kind", "items", "next_cursor"],
              additionalProperties: false,
            },
            meta: { $ref: "#/$defs/SuccessMeta" },
          },
          required: ["ok", "data", "meta"],
          additionalProperties: false,
        },
      ],
    },
  },
};
const messages: Record<Error["error"]["code"], string> = {
  unauthenticated:
    "Your session ended. Sign in again. Your form has not been submitted.",
  not_available:
    "This item is unavailable in this company workspace. Refresh your access or contact your prime administrator.",
  permission_denied:
    "Your current access does not permit this action. Your changes were not submitted.",
  mfa_required:
    "Verify your authenticator before continuing. Your form is preserved.",
  step_up_required:
    "Verify your authenticator again before this action. Your form is preserved.",
  conflict:
    "This item changed or this request was already processed. Check its current status before retrying.",
  invalid_input:
    "This request was not accepted. Review your entries and try again. Your form is preserved.",
  rate_limited:
    "Too many requests. Wait before retrying. Your form is preserved.",
  policy_unconfigured:
    "This workflow is not configured for collection or delivery yet. Nothing was submitted. Contact your prime administrator.",
  temporary_failure:
    "We could not confirm completion. Your form is preserved. Check the current status before retrying.",
};
export class PartnerApiError extends globalThis.Error {
  constructor(
    public readonly code: Error["error"]["code"],
    public readonly requestId?: string,
  ) {
    super(messages[code]);
    this.name = "PartnerApiError";
  }
}
export function partnerError(error: unknown): string {
  return error instanceof PartnerApiError
    ? error.message
    : messages.temporary_failure;
}
export function validatePartnerValue(schema: Schema, value: unknown): boolean {
  if (schema.$ref)
    return validatePartnerValue(
      definitions[schema.$ref.split("/").pop()!],
      value,
    );
  if ("const" in schema && value !== schema.const) return false;
  if (schema.enum && !schema.enum.includes(value)) return false;
  if (schema.oneOf)
    return (
      schema.oneOf.filter((s) => validatePartnerValue(s, value)).length === 1
    );
  if (schema.anyOf)
    return schema.anyOf.some((s) => validatePartnerValue(s, value));
  if (schema.type === "null") return value === null;
  if (schema.type === "object") {
    if (!value || typeof value !== "object" || Array.isArray(value))
      return false;
    const record = value as Record<string, unknown>;
    if (schema.required?.some((k) => !(k in record))) return false;
    if (
      schema.additionalProperties === false &&
      Object.keys(record).some((k) => !schema.properties?.[k])
    )
      return false;
    return Object.entries(record).every(
      ([k, v]) =>
        !schema.properties?.[k] ||
        validatePartnerValue(schema.properties[k], v),
    );
  }
  if (schema.type === "array")
    return (
      Array.isArray(value) &&
      (schema.maxItems === undefined || value.length <= schema.maxItems) &&
      (!schema.uniqueItems ||
        new Set(value.map((v) => JSON.stringify(v))).size === value.length) &&
      value.every((v) => validatePartnerValue(schema.items!, v))
    );
  if (schema.type === "boolean") return typeof value === "boolean";
  if (schema.type === "number" || schema.type === "integer")
    return (
      typeof value === "number" &&
      Number.isFinite(value) &&
      (schema.type !== "integer" || Number.isInteger(value)) &&
      (schema.minimum === undefined || value >= schema.minimum) &&
      (schema.maximum === undefined || value <= schema.maximum)
    );
  if (schema.type === "string") {
    if (
      typeof value !== "string" ||
      (schema.minLength !== undefined && value.length < schema.minLength) ||
      (schema.maxLength !== undefined && value.length > schema.maxLength)
    )
      return false;
    if (schema.pattern && !new RegExp(schema.pattern).test(value)) return false;
    if (
      schema.format === "uuid" &&
      (value === "00000000-0000-0000-0000-000000000000" || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        value,
      ))
    )
      return false;
    if (schema.format === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
      return false;
    if (schema.format === "date" || schema.format === "date-time") {
      const date = value.slice(0, 10);
      if (
        !/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(date) ||
        new Date(`${date}T00:00:00Z`).toISOString().slice(0, 10) !== date
      )
        return false;
      if (schema.format === "date" && value !== date) return false;
      if (
        schema.format === "date-time" &&
        (!/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d(?:\.\d+)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(
          value,
        ) ||
          !Number.isFinite(Date.parse(value)))
      )
        return false;
    }
  }
  return true;
}
export type PartnerRequestOptions = { signal?: AbortSignal; subject?: string; primeOrgId?: string };
async function authorizedFetch<T>(
  path: string,
  init: RequestInit,
  options: PartnerRequestOptions,
  consume: (response: Response) => Promise<T>,
): Promise<T> {
  if (options.primeOrgId !== undefined && !validatePartnerValue({ type: "string", format: "uuid" }, options.primeOrgId))
    throw new PartnerApiError("invalid_input");
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (options.signal?.aborted) throw new PartnerApiError("unauthenticated");
  options.signal?.addEventListener("abort", abort, { once: true });
  const timeout = setTimeout(abort, 20_000);
  try {
    const sessionRead = supabase.auth.getSession();
    const { data, error } = await new Promise<Awaited<typeof sessionRead>>(
      (resolve, reject) => {
        const cancelled = () =>
          reject(
            new PartnerApiError(
              options.signal?.aborted ? "unauthenticated" : "temporary_failure",
            ),
          );
        controller.signal.addEventListener("abort", cancelled, { once: true });
        void sessionRead
          .then(resolve, reject)
          .finally(() =>
            controller.signal.removeEventListener("abort", cancelled),
          );
        if (controller.signal.aborted) cancelled();
      },
    );
    if (
      error ||
      !data.session ||
      (options.subject && data.session.user.id !== options.subject) ||
      controller.signal.aborted
    )
      throw new PartnerApiError("unauthenticated");
    const response = await fetch(`${SUPABASE_URL}${path}`, {
      ...init,
      signal: controller.signal,
      credentials: "omit",
      cache: "no-store",
      headers: (() => {
        const input = new Headers(init.headers);
        const headers = new Headers({
          apikey: SUPABASE_PUBLISHABLE_KEY,
          Authorization: `Bearer ${data.session.access_token}`,
        });
        if (options.primeOrgId) headers.set("X-Akiva-Organization-Id", options.primeOrgId);
        for (const name of ["Content-Type", "Accept", "Idempotency-Key"]) {
          const value = input.get(name);
          if (value) headers.set(name, value);
        }
        return headers;
      })(),
    });
    // Keep cancellation and timeout active through the complete response body.
    return await consume(response);
  } catch (error) {
    if (controller.signal.aborted)
      throw new PartnerApiError(
        options.signal?.aborted ? "unauthenticated" : "temporary_failure",
      );
    if (error instanceof PartnerApiError) throw error;
    throw new PartnerApiError(
      options.signal?.aborted ? "unauthenticated" : "temporary_failure",
    );
  } finally {
    clearTimeout(timeout);
    options.signal?.removeEventListener("abort", abort);
  }
}
async function failure(response: Response): Promise<never> {
  const body: unknown = await response.json().catch(() => null);
  if (validatePartnerValue(definitions.Error, body)) {
    const safe = body as Error;
    throw new PartnerApiError(safe.error.code, safe.error.request_id);
  }
  throw new PartnerApiError(
    response.status === 401 ? "unauthenticated" : "temporary_failure",
  );
}
export async function requestPartner<O extends PartnerOperation>(
  operation: O,
  payload: PartnerRequests[O],
  options: PartnerRequestOptions = {},
): Promise<PartnerResults[O]> {
  const descriptor = operations[operation];
  if (payload && "action" in payload)
    throw new PartnerApiError("invalid_input");
  const body = { ...payload, action: operation };
  if (!validatePartnerValue(descriptor.request, body))
    throw new PartnerApiError("invalid_input");
  return authorizedFetch(
    descriptor.path,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
    options,
    async (response) => {
      if (!response.ok) return failure(response);
      const result: unknown = await response.json().catch(() => null);
      if (!validatePartnerValue(descriptor.response, result))
        throw new PartnerApiError("temporary_failure");
      if (options.signal?.aborted) throw new PartnerApiError("unauthenticated");
      if (
        operation === "get_prime_partner_source_options" &&
        (result as { data: { kind: unknown } }).data.kind !==
          (payload as { kind?: unknown }).kind
      )
        throw new PartnerApiError("temporary_failure");
      return (result as { data: PartnerResults[O] }).data;
    },
  );
}
export async function uploadPartnerDocument(
  metadata: DocumentMetadata,
  file: File,
  key: string,
  options: PartnerRequestOptions,
): Promise<Document> {
  if (
    !validatePartnerValue(definitions.DocumentMetadata, metadata) ||
    !validatePartnerValue({ type: "string", format: "uuid" }, key) ||
    file.size < 1 ||
    file.size > 10 * 1024 * 1024
  )
    throw new PartnerApiError("invalid_input");
  const form = new FormData();
  form.append("metadata", JSON.stringify(metadata));
  form.append("file", file);
  return authorizedFetch(
    "/functions/v1/partner-documents/upload",
    { method: "POST", headers: { "Idempotency-Key": key }, body: form },
    options,
    async (response) => {
      if (!response.ok) return failure(response);
      const result: unknown = await response.json().catch(() => null);
      if (
        !validatePartnerValue(
          {
            type: "object",
            properties: {
              ok: { const: true },
              data: { $ref: "#/$defs/Document" },
              meta: { $ref: "#/$defs/SuccessMeta" },
            },
            required: ["ok", "data", "meta"],
            additionalProperties: false,
          },
          result,
        )
      )
        throw new PartnerApiError("temporary_failure");
      if (options.signal?.aborted) throw new PartnerApiError("unauthenticated");
      return (result as { data: Document }).data;
    },
  );
}
export async function downloadPartnerDocument(
  relationship: string,
  document: Document,
  options: PartnerRequestOptions,
): Promise<void> {
  return authorizedFetch(
    `/functions/v1/partner-documents/${encodeURIComponent(document.document_id)}?relationship_id=${encodeURIComponent(relationship)}`,
    { method: "GET" },
    options,
    async (response) => {
      if (!response.ok) return failure(response);
      if (
        response.status !== 200 ||
        !response.headers.get("cache-control")?.includes("no-store") ||
        response.headers.get("x-content-type-options") !== "nosniff" ||
        response.headers
          .get("content-type")
          ?.split(";")[0]
          .trim()
          .toLowerCase() !== document.media_type
      ) {
        await response.body?.cancel().catch(() => undefined);
        throw new PartnerApiError("temporary_failure");
      }
      const reader = response.body?.getReader();
      if (!reader) throw new PartnerApiError("temporary_failure");
      const chunks: Uint8Array<ArrayBuffer>[] = [];
      let bytes = 0;
      while (true) {
        const result = await reader.read();
        if (result.done) break;
        bytes += result.value.byteLength;
        if (bytes > 10 * 1024 * 1024 || options.signal?.aborted) {
          await reader.cancel();
          throw new PartnerApiError(
            options.signal?.aborted ? "unauthenticated" : "temporary_failure",
          );
        }
        chunks.push(new Uint8Array(result.value));
      }
      if (options.signal?.aborted) throw new PartnerApiError("unauthenticated");
      if (bytes < 1 || bytes !== document.bytes)
        throw new PartnerApiError("temporary_failure");
      const url = URL.createObjectURL(
        new Blob(chunks, { type: document.media_type }),
      );
      try {
        const a = globalThis.document.createElement("a");
        a.href = url;
        const extension = {
          "text/plain": "txt",
          "application/pdf": "pdf",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            "docx",
        }[document.media_type];
        let stem =
          Array.from(document.title.replace(/\p{Cf}/gu, ""))
            .map((c) =>
              c.charCodeAt(0) < 32 || '<>:"/\\|?*'.includes(c) ? "_" : c,
            )
            .join("")
            .replace(/\.[^.]*$/, "")
            .replace(/[. ]+$/, "")
            .trim()
            .slice(0, 120) || "document";
        if (/^(con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i.test(stem))
          stem = `document-${stem}`;
        a.download = `${stem}.${extension}`;
        a.click();
      } finally {
        const revoke = URL.revokeObjectURL.bind(URL);
        setTimeout(() => revoke(url), 0);
      }
    },
  );
}
export const PARTNER_ACTIVATION_KEY = "akiva_partner_activation";
export const PARTNER_ACTIVATION_TTL_MS = 30 * 60 * 1000;
export type PartnerActivation = {
  invitation_id: string;
  captured_at: number;
  expires_at: number;
  partner_invite_token: string;
};
export function clearPartnerActivationContinuation() {
  try {
    sessionStorage.removeItem(PARTNER_ACTIVATION_KEY);
  } catch {
    /* Unavailable tab storage cannot provide a readable continuation. */
  }
}
function storedPartnerActivation(): PartnerActivation | null {
  const invalid = () => {
    clearPartnerActivationContinuation();
    return null;
  };
  try {
    const value: unknown = JSON.parse(
      sessionStorage.getItem(PARTNER_ACTIVATION_KEY) ?? "null",
    );
    if (!value || typeof value !== "object" || Array.isArray(value))
      return invalid();
    const item = value as Record<string, unknown>;
    if (
      Object.keys(item).some(
        (k) =>
          ![
            "invitation_id",
            "partner_invite_token",
            "captured_at",
            "expires_at",
          ].includes(k),
      ) ||
      typeof item.invitation_id !== "string" ||
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
        item.invitation_id,
      ) ||
      typeof item.partner_invite_token !== "string" ||
      !/^[A-Za-z0-9_-]{43,256}$/.test(item.partner_invite_token)
    )
      return invalid();
    const now = Date.now();
    if (
      typeof item.captured_at !== "number" ||
      typeof item.expires_at !== "number" ||
      !Number.isFinite(item.captured_at) ||
      !Number.isFinite(item.expires_at) ||
      item.captured_at > now ||
      item.expires_at <= now ||
      item.expires_at <= item.captured_at ||
      item.expires_at - item.captured_at > PARTNER_ACTIVATION_TTL_MS
    )
      return invalid();
    return item as PartnerActivation;
  } catch {
    return invalid();
  }
}
export function capturePartnerActivation(): PartnerActivation | null {
  if (typeof window === "undefined") return null;
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const raw = hash.get("partner_invite_token");
  if (window.location.hash)
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search,
    );
  if (raw) {
    const now = Date.now();
    const carriedExpiry = hash.get("invitation_expires_at");
    const linkExpiry = carriedExpiry
      ? Date.parse(carriedExpiry)
      : now + PARTNER_ACTIVATION_TTL_MS;
    if (!Number.isFinite(linkExpiry) || linkExpiry <= now) {
      clearPartnerActivationContinuation();
      return null;
    }
    const value: PartnerActivation = {
      captured_at: now,
      expires_at: Math.min(now + PARTNER_ACTIVATION_TTL_MS, linkExpiry),
      invitation_id: hash.get("invitation_id") ?? "",
      partner_invite_token: raw,
    };
    if (
      !/^[A-Za-z0-9_-]{43,256}$/.test(raw) ||
      !validatePartnerValue(
        { type: "string", format: "uuid" },
        value.invitation_id,
      )
    ) {
      clearPartnerActivationContinuation();
      return null;
    }
    try {
      sessionStorage.setItem(PARTNER_ACTIVATION_KEY, JSON.stringify(value));
    } catch {
      /* Explicit activation can continue in this mounted page; cross-page continuation is unavailable. */
    }
    return value;
  }
  const stored = storedPartnerActivation();
  if (!stored) clearPartnerActivationContinuation();
  return stored;
}
export function hasPartnerActivationContinuation(): boolean {
  return storedPartnerActivation() !== null;
}
